import * as yup from 'yup';
import { validateBr } from 'js-brasil';
import moment from 'moment';

export const personalSchema = yup.object({
  cpf: yup
    .string()
    .required('CPF é obrigatório')
    .test('cpf', 'CPF inválido', (val) => !val || validateBr.cpf(val)),
  name: yup.string().required('Campo obrigatório'),
  email: yup.string().email('Email inválido').required('Campo obrigatório'),
  cell_phone: yup.string().required('Campo obrigatório'),
  birth_date: yup
    .string()
    .required('Campo obrigatório')
    .test(
      'date',
      'Insira uma data válida',
      (val) =>
        !val ||
        (moment(val, 'DD/MM/YYYY', true).isValid() &&
          moment(val, 'DD/MM/YYYY').isBefore(moment().subtract(1, 'day')))
    ),
  genre: yup.string().nullable(),
  civil_status: yup.string().nullable(),
  password: yup
    .string()
    .required('Campo obrigatório')
    .min(6, 'Senha muito curta'),
  password_confirm: yup
    .string()
    .oneOf([yup.ref('password')], 'As senhas devem ser iguais!')
    .required('Confirme a senha'),
});

export const addressSchema = yup.object({
  address: yup.object({
    code_post: yup.string().required('Campo obrigatório'),
    street: yup.string().required('Campo obrigatório'),
    number: yup.string().required('Campo obrigatório'),
    district: yup.string().required('Campo obrigatório'),
    complement: yup.string().nullable(),
    city: yup.object({
      id: yup.number().nullable().required('Busque um CEP válido'),
      name: yup.string().required('Campo obrigatório'),
      state: yup.object({
        id: yup.number().nullable(),
        name: yup.string().required('Campo obrigatório'),
      }),
    }),
  }),
});

export const professionalSchema = yup.object({
  crm: yup.object({
    number: yup.string().required('Campo obrigatório'),
    state: yup
      .object({
        id: yup.number().required('Campo obrigatório'),
        name: yup.string(),
        uc: yup.string(),
      })
      .nullable()
      .required('Campo obrigatório'),
  }),
  specialties: yup
    .array()
    .min(1, 'Selecione pelo menos uma especialidade')
    .required('Selecione pelo menos uma especialidade'),
});

export const stepSchemas = [personalSchema, addressSchema, professionalSchema];
